import { Box, HStack, Square, Stack, Icon, Text } from '@chakra-ui/react';
import { TODO } from '@habity/types';
import { ReactNode } from 'react';
import { IconType } from 'react-icons';

type ActionRowType = {
  index: TODO;
  name: string;
  description?: string;
  icon?: IconType;
  button: ReactNode;
};

export const ActionRow = ({
  name,
  index,
  description,
  icon,
  button,
}: ActionRowType) => {
  return (
    <Box key={`${name}-${index}`}>
      <HStack justifyContent="space-between" alignItems="center" spacing="5">
        <HStack spacing="3">
          {icon && <Icon as={icon} boxSize="6" />}
          <Box>
            <Text color="black" fontSize="sm" fontWeight="semibold">
              {name}
            </Text>
            {description && (
              <Text
                display={{ mobile: 'none', desktop: 'block' }}
                color="blackAlpha.700"
                fontSize="xs"
              >
                {description}
              </Text>
            )}
          </Box>
        </HStack>
        <Box>
          {button}
        </Box>
      </HStack>
    </Box>
  );
};
